module.exports = {
        srcSet: "/_next/static/images/app-store-128-e1b98902eba3ead6.png"+" 128w"+","+"/_next/static/images/app-store-256-a6b581f236e94b04.png"+" 256w"+","+"/_next/static/images/app-store-314-0785ee83eabd86fb.png"+" 314w",
        images: [{path: "/_next/static/images/app-store-128-e1b98902eba3ead6.png",width: 128,height: 46},{path: "/_next/static/images/app-store-256-a6b581f236e94b04.png",width: 256,height: 93},{path: "/_next/static/images/app-store-314-0785ee83eabd86fb.png",width: 314,height: 114}],
        src: "/_next/static/images/app-store-314-0785ee83eabd86fb.png",
        toString: function(){return "/_next/static/images/app-store-314-0785ee83eabd86fb.png"},
        
        width: 314,
        height: 114
      }